import cx from 'classnames';
import { Card, ICardProps } from 'components/admin/ui';
import { ChevronRight } from 'ethena-icons';
import { ElementType, HTMLAttributes, ReactNode } from 'react';
import css from './SummaryCard.module.scss';

/** @deprecated Use `components/ui/SummaryCard` instead. */
const SummaryCard = ({ className, ...rest }: ICardProps) => (
  <Card className={cx(css.summaryCard, className)} {...rest} />
);

const Actions = ({ className, ...rest }: HTMLAttributes<HTMLDivElement>) => (
  <div className={cx(css.actions, className)} {...rest} />
);

interface IColProps extends HTMLAttributes<HTMLDivElement> {
  variant?: 'title';
}

const Col = ({ className, variant, ...rest }: IColProps) => (
  <div
    className={cx(css.col, { [css.titleCol]: variant === 'title' }, className)}
    {...rest}
  />
);

const Content = ({ className, ...rest }: HTMLAttributes<HTMLDivElement>) => (
  <div className={cx(css.content, className)} {...rest} />
);

const Eyebrow = ({
  className,
  color,
  ...rest
}: HTMLAttributes<HTMLDivElement>) => (
  <div className={cx(css.eyebrow, className)} style={{ color }} {...rest} />
);

const Title = ({ className, ...rest }: HTMLAttributes<HTMLDivElement>) => (
  <h1 className={cx(css.title, className)} {...rest} />
);

export interface IPropertyProps {
  className?: string;
  icon: ElementType;
  includeChevron?: boolean;
  isDisabled?: boolean;
  label?: string;
  onClick?: () => void;
  value: ReactNode;
  valueClassName?: string;
}

const Property = ({
  className,
  icon: Icon,
  includeChevron,
  isDisabled,
  label,
  onClick,
  value,
  valueClassName,
}: IPropertyProps) => {
  const isClickable = !!onClick;
  const renderLabel = () => label && `${label}: `;
  return isClickable ? (
    <button
      className={cx(css.property, className)}
      disabled={isDisabled}
      onClick={onClick}
    >
      <Icon className={css.icon} height={14} width={14} />
      {renderLabel()}
      <span
        className={cx(css.value, {
          [css.withChevron]: includeChevron,
        })}
      >
        {value}
        {includeChevron && (
          <ChevronRight className={css.chevron} height={16} width={16} />
        )}
      </span>
    </button>
  ) : (
    <div className={cx(css.property, className)}>
      <Icon className={css.icon} height={14} width={14} />
      {renderLabel()}
      <span className={cx(css.value, valueClassName)}>{value}</span>
    </div>
  );
};

SummaryCard.Actions = Actions;
SummaryCard.Col = Col;
SummaryCard.Content = Content;
SummaryCard.Eyebrow = Eyebrow;
SummaryCard.Property = Property;
SummaryCard.Title = Title;

export { SummaryCard };
